import React from 'react';
import BackBtn from '../../../components/UI/BackBtn';
import StratProjReport from '../../StratProjReport';
import { useProjectForNav } from '../../../hooks/useProjectForNav';
import useNavProject from '../../../hooks/useNavProject';
import useAPI from '../../../hooks/useAPI';

function InnerPageComponent({
  projId, header, backAction, children,
}) {
  const navProject = useNavProject();
  const api = useAPI();
  useProjectForNav(api, navProject, projId);

  return (
    <section className="page project-page" style={{ backgroundColor: '#F5F5FF' }}>
      <div className="container">
        <BackBtn onClick={backAction} />
        <div className="project-title-wrapper" style={{ paddingBottom: '0', color: '#1F2125' }}>
          <h2>{header}</h2>
        </div>
        <div>
          {children}
        </div>
      </div>
    </section>
  );
}

export default InnerPageComponent;
